<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("BUTTONS.add_notification") }}</h4>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <!-- Start:: Title Ar Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleAr')"
                v-model.trim="data.titleAr"
                required
              />
              <!-- End:: Title Ar Input -->

              <!-- Start:: Title En Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleEn')"
                v-model.trim="data.titleEn"
                required
              />
              <!-- End:: Title En Input -->

              <!-- Start:: Content Ar Input -->
              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentAr')"
                v-model.trim="data.contentAr"
                required
              />
              <!-- End:: Content Ar Input -->

              <!-- Start:: Content En Input -->
              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentEn')"
                v-model.trim="data.contentEn"
                required
              />
              <!-- End:: Content En Input -->
              <!-- Start:: Receiver Type Input -->
              <base-select-input
                col="6"
                :optionsList="receiverTypes"
                :placeholder="$t('PLACEHOLDERS.receiverType')"
                v-model="data.receiverType"
                required
              />
              <!-- End:: Receiver Type Input -->

              <!-- Start:: Users Selection Input -->
              <base-select-input
                v-if="data.receiverType && data.receiverType?.value !== 'all'"
                col="6"
                :optionsList="users"
                :placeholder="$t('PLACEHOLDERS.selectUsers')"
                v-model="data.selectedUsers"
                multiple
                required
              />
              <!-- End:: Users Selection Input -->
            </div>
          </div>

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateNotification",

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      allClientsData: "ApiGetsModule/allClientsData",
      allDriversData: "ApiGetsModule/allDriversData",
    }),
    // End:: Vuex Getters

    receiverTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.individual"),
          value: "individual",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.store"),
          value: "store",
        },
        {
          id: 3,
          name: this.$t("PLACEHOLDERS.both"),
          value: "both",
        },
        {
          id: 4,
          name: this.$t("PLACEHOLDERS.all"),
          value: "all",
        },
      ];
    },
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Users List
      users: [],
      // End:: Users List

      // Start:: Data Collection To Send
      data: {
        receiverType: null,
        selectedUsers: [],
        titleAr: null,
        titleEn: null,
        contentAr: null,
        contentEn: null,
      },

      // End:: Data Collection To Send
    };
  },
  watch: {
    "data.receiverType"(newVal) {
      if (newVal) {
        this.data.selectedUsers = [];
        if (newVal.value !== "all") {
          this.getUsers();
        }
      }
    },
  },

  methods: {
    // Start:: Get Users Based on Type
    async getUsers() {
      try {
        let res = await this.$axios({
          method: "POST",
          url: "admin-notifications/get-users",
          data: {
            type: this.data.receiverType?.value,
          },
        });

        this.users = res.data.data.users.map((user) => ({
          id: user.id,
          name: user.name,
          value: user.id,
        }));
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
        this.$message.error(this.$t("MESSAGES.errorOccurred"));
      }
    },
    // End:: Get Users Based on Type

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.receiverType) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.receiverType"));
        return;
      } else if (
        this.data.receiverType?.value !== "all" &&
        (!this.data.selectedUsers || this.data.selectedUsers.length === 0)
      ) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.selectAtLeastOneUser"));
        return;
      } else if (!this.data.titleAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.titleAr"));
        return;
      } else if (!this.data.titleEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.titleEn"));
        return;
      } else if (!this.data.contentAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.contentAr"));
        return;
      } else if (!this.data.contentEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.contentEn"));
        return;
      } else {
        this.submitForm();
        return;
      }
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();

      // Only append recipient_user_ids if type is not 'all'
      if (this.data.receiverType?.value !== "all") {
        this.data.selectedUsers.forEach((user) => {
          REQUEST_DATA.append("recipient_user_ids[]", user.id);
        });
      }

      REQUEST_DATA.append("recipient_type", this.data.receiverType?.value);
      REQUEST_DATA.append("title_ar", this.data.titleAr);
      REQUEST_DATA.append("title_en", this.data.titleEn);
      REQUEST_DATA.append("content_ar", this.data.contentAr);
      REQUEST_DATA.append("content_en", this.data.contentEn);

      try {
        await this.$axios({
          method: "POST",
          url: "admin-notifications",
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.sentSuccessfully"));
        this.$router.push({ path: "/all-notifications/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.errorOccurred")
        );
      }
    },
    // End:: Submit Form
  },

  mounted() {
    // No need to fetch data on mount, it will be fetched when receiverType changes
  },
};
</script>
